export default __webpack_public_path__ + "static/5-37322fad1be6dfab38241669ffd15cce.png";